import React, { Suspense } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { authProtectedRoutes, publicRoutes } from './optimizedRoutes';
import Layout from 'Layout';
import NonAuthLayout from "Layout/NonLayout"
import AuthProtected from './AuthProtected';
import PageLoading from '../components/LoadingStates/PageLoading';

const RouteIndex = () => {
  return (
    <React.Fragment>
      <Routes>
        {/* Redirect from root to dashboard */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        
        {authProtectedRoutes.map((route: any, idx: number) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <AuthProtected>
                <Layout>
                  <Suspense fallback={<PageLoading />}>
                    <route.component />
                  </Suspense>
                </Layout>
              </AuthProtected>
            }
          />
        ))}
        {publicRoutes.map((route: any, idx: number) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <NonAuthLayout>
                <Suspense fallback={<PageLoading />}>
                  <route.component />
                </Suspense>
              </NonAuthLayout>
            } />
        ))}
      </Routes>
    </React.Fragment>
  );
};

export default RouteIndex;
